import { Button, Box, Modal, Typography, Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { trackEvent } from "../utils/Utils";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "80%", md: "50%", lg: "40%" },
  maxHeight: "90vh",
  bgcolor: "background.paper",
  borderRadius: "24px",
  boxShadow: "0 24px 48px rgba(0,0,0,0.2)",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  overflowY: "auto",
  p: { xs: 3, md: 5 },
};

export default function ConfirmationModal({
  open,
  onClose,
  onConfirm,
  title,
  message,
  alertSeverity,
  showCancel = true,
}) {
  const { t } = useTranslation();

  const handleConfirm = () => {
    trackEvent("confirmationmodal-confirmed");
    onConfirm();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2" gutterBottom>
          {title}
        </Typography>

        <Alert severity={alertSeverity || "warning"}>{message}</Alert>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}>
          {showCancel && (
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{ borderRadius: "8px", fontWeight: "bold", borderWidth: "2px", "&:hover": { borderWidth: "2px" }, px: 3, py: 1 }}
            >
              {t("confirmationModal.cancel")}
            </Button>
          )}
          <Button
            variant="contained"
            color="error"
            onClick={handleConfirm}
            sx={{ borderRadius: "8px", fontWeight: "bold", px: 3, py: 1, boxShadow: "0 4px 14px 0 rgba(226, 114, 110, 0.39)" }}
          >
            {t("confirmationModal.confirm")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
